import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import BoringAvatar from "boring-avatars";
import * as yup from "yup";
import { Badge } from "~/components/ui/badge";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { Textarea } from "~/components/ui/textarea";
import { AGENT_BRAND_COLORS, Agent, AgentScope } from "~/services/agents";
import { StatusBadge } from "./StatusBadge";

const schema = yup.object({
  display_name: yup.string().trim().required("Name is required"),
  description: yup.string().defined(),
});

type FormValues = yup.InferType<typeof schema>;

export const AgentProfileTab = () => {
  const agent = useOutletContext<Agent>();

  const {
    register,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      display_name: agent.display_name,
      description: agent.description ?? "",
    },
  });

  return (
    <div className="flex max-w-2xl flex-col gap-6">
      <div className="flex items-start gap-4">
        <div className="flex shrink-0 flex-col items-center gap-2">
          <div className="size-20 overflow-hidden rounded-full">
            <BoringAvatar size={80} name={agent.name} variant="beam" colors={AGENT_BRAND_COLORS} />
          </div>
          <StatusBadge status={agent.status} />
          {agent.scope === AgentScope.SYSTEM && (
            <Badge variant="outline" className="rounded-full">
              System
            </Badge>
          )}
        </div>

        <div className="flex flex-1 flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="display_name">Name</Label>
            <Input
              id="display_name"
              disabled
              aria-invalid={!!errors.display_name}
              {...register("display_name")}
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <Label htmlFor="description">Description</Label>
            <Textarea id="description" rows={3} disabled {...register("description")} />
          </div>
        </div>
      </div>

      {agent.persona && (
        <div className="flex flex-col gap-1.5">
          <Label>Persona</Label>
          <Textarea value={agent.persona} rows={10} disabled className="resize-none" readOnly />
        </div>
      )}
    </div>
  );
};
